/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Device Management
 * Device Manager API CRUD https://bitbucket.org/nwaveio/device-management-openapi/src/master/
 *
 * The version of the OpenAPI document: 2.1.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    LabelCount,
} from './';

/**
 * @export
 * @interface Level
 */
export interface Level {
    /**
     * `Level Primary Key`
     * @type {number}
     * @memberof Level
     */
    readonly id: number;
    /**
     * `Zone Primary Key`
     * @type {number}
     * @memberof Level
     */
    readonly zone_id: number;
    /**
     * @type {string}
     * @memberof Level
     */
    name: string;
    /**
     * ***Position group floor number***
     * @type {number}
     * @memberof Level
     */
    floor_number: number;
    /**
     * @type {Date}
     * @memberof Level
     */
    creation_date?: Date;
    /**
     * @type {Array<LabelCount>}
     * @memberof Level
     */
    labels?: Array<LabelCount>;
}
